import styled from "styled-components";
import { colors } from "theme";

export const Link = styled.a`
    color: ${colors.linkColor};
    font-family: 'Inter';
    font-weight: 500;
    overflow-wrap: break-word;
    text-decoration: underline;
    cursor: pointer;
`